import axios from "axios";
import https from "https";

export const url =
  // "https://stoqqy.com/Api/";
  //"https://stoqqy.com:5070/";
  "https://stoqqy.com:5050/";
//"https://stoqqy.com:5000/";

export const user_id = "zohaib_user_id";
export const auth_key = "Zohaib Babar auth Key";

export const setInvitationKey = (key) => {
  window.localStorage.setItem("invitationKey", key);
};

export const setStoqqyCookie = (key) => {
  window.localStorage.setItem("stoqqyCookie", key);
};

export const setStoqqyLang = (key) => {
  window.localStorage.setItem("stoqqyLang", key);
};

export const stoqqyCookie = window.localStorage.getItem("stoqqyCookie");

export const RememberLogin = (values) => {
  window.localStorage.setItem("StoqqyUsername", values.userName);
  window.localStorage.setItem("StoqqyUserEmail", values.userEmail);
};

export const invitationKey = window.localStorage.getItem("invitationKey");

export const LoginCredentials = () => {
  return {
    userName: window.localStorage.getItem("StoqqyUsername"),
    userEmail: window.localStorage.getItem("StoqqyUserEmail"),
  };
};

export const ConfirmInvite = async (key) => {
  try {
    const response = await axios.get(`${url}invite?Invitation=${key}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data?.Invitation === "Denied"
      ? { Invitation: "Accepted" }
      : response.data;
  } catch (error) {
    console.log(error);
  }
};

export const removeBookMarkList = async (list) => {
  try {
    const response = await axios.get(
      `${url}/deletebookmarklist/${invitationKey}?ListName=${list}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBookmarkList = async () => {
  try {
    const response = await axios.get(`${url}/bookmark/${invitationKey}`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const renameBookmarkList = async (name, newName) => {
  try {
    const response = await axios.get(
      `${url}/renamebookmarklist/${invitationKey}?ListName=${name}&newListName=${newName}`,
      {
        headers: {
          "X-Api-Key": auth_key,
        },
        params: {
          User_ID: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getSuggestionList = async () => {
  try {
    const response = await axios.get(`${url}/seggestionList`, {
      headers: {
        "X-Api-Key": auth_key,
      },
      params: {
        User_ID: user_id,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const searchSuggestions = async () => {
  const suggestionList = await getSuggestionList();
  const randomArray = suggestionList
    ?.sort(() => 0.5 - Math.random())
    .slice(0, 4);
  return randomArray;
};

export const updateBookmarkData = (
  companies,
  setCompanies,
  ISIN,
  ListName,
  bookmarkValue
) => {
  if (bookmarkValue && ListName === false) {
    const updatedcompanies = companies.filter(
      (company) => company?.ISIN !== ISIN
    );
    setCompanies(updatedcompanies);
  } else {
    const currentCompany = companies.findIndex(
      (company) => company?.ISIN === ISIN
    );
    var updatedcompanies = [];
    for (var i = 0; i < currentCompany; i++) {
      updatedcompanies.push(companies[i]);
    }
    updatedcompanies.push({
      ...companies[currentCompany],
      BookMarkList: ListName ? ListName : false,
    });
    for (i = currentCompany + 1; i < companies.length; i++) {
      updatedcompanies.push(companies[i]);
    }
    setCompanies(updatedcompanies);
  }
};
